export function parseChildren(children){return children?.type?.target||children?.type}
//# sourceMappingURL=parse-children.js.map